// extracted by mini-css-extract-plugin
module.exports = {"component":"SearchInput_component__Xgn0X","input":"SearchInput_input__2wCi4"};